export default function isNotAuthorizedOnError(dispatch: any, error: any) {
  if (error?.code === 401) {
    dispatch.authentication.logout(401);
  }
}
